module.exports = __webpack_public_path__ + "img/icon48.5b0f814b.png";